import React, {Component} from 'react';
import './PublicClient.scss';
import {OIDC_PUBLIC_CLIENT_LABEL, OIDC_PUBLIC_CLIENT_INFO} from "../../../shared/messages";
import {PropTypes} from "prop-types";


class PublicClient extends Component {
    static propTypes = {
        isPublicClient: PropTypes.bool,
    }

    updateIsPublicClient= (e) => {
        this.props.updateIsPublicClient(e.target.checked);
    }


render() {
    const isChecked = Boolean(this.props.isPublicClient)
    return (
        <div className='copy-row'>
            <input id='isPublicClient' type="checkbox" className="public-client-checkbox"
                   checked={isChecked}
                   value={isChecked}
                   onChange={this.updateIsPublicClient}
            />

            <div className='public-client-column'>
            <span className='public-client-label'>{OIDC_PUBLIC_CLIENT_LABEL}</span>
            <span className='public-client-info'>{OIDC_PUBLIC_CLIENT_INFO}</span>
            </div>

        </div>
    );
}
}

export default PublicClient;